import React from 'react';
import LocationTemplate from './LocationTemplate';

const LittletonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Littleton"
      stateName="North Carolina"
      countyName="Halifax"
      zipCodes={["27850"]}
      latitude={36.4340}
      longitude={-77.9090}
      population={692}
      historicalFact="Founded in 1890 as a railroad town, named after early settler William Littleton."
      nearbyTowns={[
        "Warrenton, NC",
        "Halifax, NC",
        "Weldon, NC",
        "Enfield, NC",
        "Roanoke Rapids, NC",
        "Henderson, NC",
        "Norlina, NC",
        "Hollister, NC"
      ]}
    />
  );
};

export default LittletonPage;